exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotel-changes[data-v-3131d984]{background-color:#f0f0f0;height:100%}.hotel-changes-container[data-v-3131d984]{padding:20px;width:100%}", ""]);

// exports
